// Pure helpers that turn an AI View interpretation + the user's reference selections into the
// payloads the existing dashboard endpoints expect. Kept side-effect-free for unit testing.

// A reference_search targets vendors when its column is the vendor name; otherwise it's an
// employee reference (e.g. invoice_entered_by_id).
export const isVendorReference = (reference) =>
  reference?.database_column_name === 'vendor_name'

// POST /users/:id/dashboards body (objectName 'dashboard' wraps this).
export const buildDashboardParams = ({ sectionId, name, filters }) => ({
  section_id: sectionId,
  name: (name || '').trim(),
  params: filters || {}
})

// dashboard_employees/bulk_create expects [{ id, database_column_name }] — stamp the reference
// column onto each selected employee.
export const buildEmployeeRecords = (employeeIds, databaseColumnName) =>
  (employeeIds || []).map((id) => ({ id, database_column_name: databaseColumnName }))

// Merge the user's option-resolution picks (select/multiselect/mcc_select disambiguation) into the
// filter params before creating the View. Each entry is { accessor_key, filter_type, mode, values }.
// select writes a single value; multiselect/mcc_select merge into an array (+ Mode when 'exclude').
export const mergeResolvedOptions = (filters, resolvedOptions) => {
  const merged = { ...(filters || {}) }
  ;(resolvedOptions || []).forEach(({ accessor_key, filter_type, mode, values }) => {
    if (!accessor_key || !values || values.length === 0) return
    if (filter_type === 'select') {
      merged[accessor_key] = values[0]
    } else {
      const existing = Array.isArray(merged[accessor_key])
        ? merged[accessor_key]
        : (merged[accessor_key] ? [merged[accessor_key]] : [])
      merged[accessor_key] = Array.from(new Set([...existing, ...values]))
      if (mode === 'exclude') merged[`${accessor_key}Mode`] = 'exclude'
    }
  })
  return merged
}
